export const importJustifiTokenizePaymentMethod = () => {
  return import('@justifi/webcomponents/dist/module/justifi-tokenize-payment-method.js');
};

export const importJustifiPaymentProvisioning = () => {
  return import('@justifi/webcomponents/dist/module/justifi-payment-provisioning.js');
};
